enum ApiStatus {
  Success = 200,
  Error = 500,
  SessionExpired = 401,
}

export { ApiStatus };
